import { Encoder, Utils } from '@everyboard/lib';
import { Move } from '../../jscaip/Move';
import { MoveCoordToCoord } from '../../jscaip/MoveCoordToCoord';
import { MoveWithTwoCoords } from '../../jscaip/MoveWithTwoCoords';
import { KamisadoState } from './KamisadoState';
class KamisadoPassMove extends Move {
    static PASS = new KamisadoPassMove();
    static encoder = Encoder.constant('PASS', KamisadoPassMove.PASS);
    constructor() {
        super();
    }
    getDistance() {
        return 0;
    }
    equals(that) {
        return this === that;
    }
    toString() {
        return 'KamisadoMove(PASS)';
    }
}
export class KamisadoPieceMove extends MoveCoordToCoord {
    static encoder = MoveWithTwoCoords.getEncoder(KamisadoPieceMove.of);
    static of(start, end) {
        Utils.assert(KamisadoState.isOnBoard(start), 'Starting coord of KamisadoMove must be on the board, not at ' + start.toString());
        Utils.assert(KamisadoState.isOnBoard(end), 'End coord of KamisadoMove must be on the board, not at ' + end.toString());
        return new KamisadoPieceMove(start, end);
    }
    constructor(start, end) {
        super(start, end);
    }
    equals(other) {
        if (other === this)
            return true;
        if (KamisadoMove.isPiece(other)) {
            if (other.getStart().equals(this.getStart()) === false)
                return false;
            return other.getEnd().equals(this.getEnd());
        }
        else {
            return false;
        }
    }
    toString() {
        return 'KamisadoMove(' + this.getStart() + '->' + this.getEnd() + ')';
    }
}
function isPass(move) {
    return move instanceof KamisadoPassMove;
}
// eslint-disable-next-line @typescript-eslint/no-redeclare
export var KamisadoMove;
(function (KamisadoMove) {
    KamisadoMove.PASS = KamisadoPassMove.PASS;
    function of(start, end) {
        return KamisadoPieceMove.of(start, end);
    }
    KamisadoMove.of = of;
    function isPiece(move) {
        return move instanceof KamisadoPieceMove;
    }
    KamisadoMove.isPiece = isPiece;
    KamisadoMove.encoder = Encoder.disjunction([KamisadoMove.isPiece, isPass], [KamisadoPieceMove.encoder, KamisadoPassMove.encoder]);
})(KamisadoMove || (KamisadoMove = {}));
